export default __webpack_public_path__ + "static/media/landing_any_data_system_2.b7ab053e.jpg";